import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CamerasStatus from "./components/CamerasStatus";
import Info from "./components/components/Info/Info";
import IpRoutesStatus from "./components/IpRoutesStatus";
import NetworkInterfacesStatus from "./components/NetworkInterfacesStatus";
import SensorsStatus from "./components/SensorsStatus";
import StarlinkStatus from "./components/StarlinkStatus";
import { useSignalR } from "../../hooks";
import diagnosticsService from "../../services/diagnosticsService";
export const Diagnostics = ({ droneId }) => {
    const { t } = useTranslation();
    const [systemStatus, setSystemStatus] = useState();
    const hubConnection = useSignalR();
    const reloadInterface = async (iface) => {
        await diagnosticsService.resetInterface(droneId, iface);
    };
    const switchRoute = async (id, value) => {
        if (value) {
            await diagnosticsService.enableRoute(droneId, id);
        }
        else {
            await diagnosticsService.disableRoute(droneId, id);
        }
    };
    const pingCameras = async () => {
        await diagnosticsService.pingCameras(droneId);
    };
    const pingGPS = async () => {
        await diagnosticsService.pingGPS(droneId);
    };
    const restartDroneService = async () => {
        await diagnosticsService.restartService(droneId);
    };
    const getSystemStatus = async () => {
        await diagnosticsService.requestSystemStatus(droneId);
    };
    useEffect(() => {
        if (hubConnection) {
            hubConnection.on("SystemStatus", onSystemStatus);
            diagnosticsService.requestSystemStatus(droneId);
            return () => {
                hubConnection.off("SystemStatus", onSystemStatus);
            };
        }
    }, [hubConnection]);
    const onSystemStatus = (status) => {
        if (status.droneId == droneId) {
            setSystemStatus(status);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "p-20", children: [_jsx("button", { className: "btn", onClick: restartDroneService, children: t("diagnostics.buttons.restart") }), _jsx("button", { className: "btn", onClick: getSystemStatus, children: t("diagnostics.buttons.refresh") })] }), _jsx(StarlinkStatus, { droneId: droneId }), systemStatus && (_jsxs("div", { children: [_jsx(NetworkInterfacesStatus, { networkData: systemStatus.networkInterfaces, onReloadInterface: reloadInterface }), _jsx(IpRoutesStatus, { ipRoutesData: systemStatus.ipRoutes, onSwitchRoute: switchRoute }), _jsx(CamerasStatus, { camerasData: systemStatus.cameras, onPingCameras: pingCameras }), _jsx(SensorsStatus, { sensors: systemStatus.sensors, onPingGPS: pingGPS }), _jsxs("div", { className: "diagnostic-wrapper", children: [_jsxs("h3", { className: "diagnostic-title", children: [t("diagnostics.sections.networkStats"), _jsx(Info, { textInfo: t("diagnostics.sections.networkStatsInfo") })] }), _jsx("div", { className: "ping-wrapper", children: systemStatus.pingStatistics &&
                                    Object.keys(systemStatus.pingStatistics).map((key) => (_jsx("div", { children: t("diagnostics.pingStats", {
                                            key,
                                            failed: systemStatus.pingStatistics[key].failedPings,
                                            avg: systemStatus.pingStatistics[key].averagePing,
                                        }) }, key))) })] })] }))] }));
};
